import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    base: '/',
    mode: "history",
    routes: [{
            path: '/',
            name: 'index',
            component: () =>
                import ('@/views/Index')
        },
        {
            path: '/buy',
            component: () =>
                import ('@/views/Buy')
        },
        {
            path: '/test',
            component: () =>
                import ('@/components/HelloWorld')
        },
        {
            path: '/:language/buy',
            name: 'buy',
            component: () =>
                import ('@/views/Buy')
        },
        {
            path: '/case',
            name: 'buy',
            component: () =>
                import ('@/views/study')
        },
        {
            path: '/case/:id',
            name: 'buyContent',
            component: () =>
                import ('@/views/study/Content')
        },
        {
            path: '/reviews',
            name: 'reviews',
            component: () =>
                import ('@/views/reviews')
        },
        {
            path: '/reviewsmsg',
            name: 'reviewsContent',
            component: () =>
                import ('@/views/reviews/Content')
        },
        {
            path: '/support',
            name: 'support',
            component: () =>
                import ('@/views/Support'),
            children: [{
                    path: 'index',
                    component: () =>
                        import ('@/views/support/Index')
                },
                {
                    path: 'nocontent',
                    component: () =>
                        import ('@/views/support/NoContent')
                },
                {
                    path: 'result',
                    component: () =>
                        import ('@/views/support/Result')
                },
                {
                    path: 'resultvideo/:id',
                    component: () =>
                        import ('@/views/support/ResultVideo')
                },
                {
                    path: 'need',
                    component: () =>
                        import ('@/views/support/Need'),
                    children: [{
                            path: 'guide',
                            component: () =>
                                import ('@/views/support/need/Guide')
                        },
                        {
                            path: 'howto',
                            component: () =>
                                import ('@/views/support/need/HowTo')
                        },
                        {
                            path: 'productoverview',
                            component: () =>
                                import ('@/views/support/need/ProductOverview')
                        },
                        {
                            path: 'videotutorials',
                            component: () =>
                                import ('@/views/support/need/VideoTutorials')
                        },
                        {
                            path: 'emailus',
                            component: () =>
                                import ('@/views/support/need/Emailus')
                        }
                    ]
                }
            ]
        },
        {
            path: '/features',
            name: 'features',
            component: () =>
                import ('@/views/Features')
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js